import { ToggleButton } from "plos/src/components/ToggleButton";
import { ToggleButtonGroup } from "plos/src/components/ToggleButtonGroup";
import { toggleWrapper } from "plos/src/components/ToggleButtonGroup/toggleButtonGroup.css";
import { useLocalizedNavigate } from "plos/src/hooks/useLocalizedNavigate";
import { localizePath } from "plos/src/utils/language";
import { Key } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";

type FixturesView = "fixtures" | "fdr";

interface FixturesToggleProps {
  selected: FixturesView;
}

const FixturesToggle = ({ selected }: FixturesToggleProps) => {
  const navigate = useLocalizedNavigate();
  const { lang } = useParams();

  const linksDict = {
    fixtures: localizePath("/fixtures", lang),
    fdr: localizePath("/fixtures/fdr", lang),
  };

  const { t } = useTranslation();

  const handleToggleChange = (keys: Set<Key>) => {
    const key = Array.from(keys)[0] as FixturesView;
    if (key) {
      navigate(linksDict[key]);
    }
  };

  return (
    <div className={toggleWrapper}>
      <ToggleButtonGroup
        selectedKeys={new Set([selected])}
        onSelectionChange={handleToggleChange}
      >
        <ToggleButton id={"fixtures"}>
          {t("fixturesToggle.fixtures", "Fixtures")}
        </ToggleButton>
        <ToggleButton id={"fdr"}>{t("fixturesToggle.fdr", "FDR")}</ToggleButton>
      </ToggleButtonGroup>
    </div>
  );
};

export default FixturesToggle;
